export default __webpack_public_path__ + "static/media/F1_6.efa1b812.png";